import { useEffect, useState } from "react";

const useOpenOnce = (featureName, lsKey, delay = 1500, setLsOnClose) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let timeout;
    const prev = getPrevLs();

    timeout = setTimeout(() => {
      setOpen(!prev?.[featureName]);
    }, delay);

    if (!setLsOnClose && !prev?.hasOwnProperty(featureName)) {
      setLs(prev);
    }

    return () => clearTimeout(timeout);
  }, [featureName]);

  const setLs = (prevLs) => {
    const newName = { [featureName]: true };
    const updatedObject = { ...prevLs, ...newName };
    const updatedObjectString = JSON.stringify(updatedObject);
    localStorage.setItem(lsKey, updatedObjectString);
  };
  const getPrevLs = () => {
    const localStorageData = localStorage.getItem(lsKey);
    const prev =
      Object.keys(localStorageData || {})?.length > 0
        ? JSON.parse(localStorageData)
        : {};
    return prev;
  };

  const setOpenFn = (val) => {
    setOpen(val);
    if (!val && !!setLsOnClose) {
      setLs(getPrevLs());
    }
  };

  return [open, setOpenFn];
};

export default useOpenOnce;
